import React from 'react';
import { useSelector } from 'react-redux';
import Rating from 'components/general/rating';

export const CompetencyRatingSetter = ({ competencies, competency_Ids, default_Competency_Values, onChange }) => {
    const [competency_Values, setCompetencyValues] = React.useState(default_Competency_Values || '{}');
    const user = useSelector(state => (state.user.user ? state.user.user : ''));
    const ratings = user.companySettings?.display?.ratingRange || 5;

    React.useEffect(() => {
        setCompetencyValues(default_Competency_Values);
    }, [default_Competency_Values]);

    React.useEffect(() => {
        if (competency_Ids) {
            const values = JSON.parse(competency_Values || '{}');
            var temp = {};
            competency_Ids.forEach(id => (temp[id] = values[id]));
            onChange(JSON.stringify(temp));
        }
    }, [competency_Ids]);

    if (!competency_Ids || competency_Ids.length === 0) {
        return null;
    }

    const values = JSON.parse(competency_Values || '{}');

    const setRating = (c, r) => {
        values[c] = r;
        const json = JSON.stringify(values);
        onChange(json);
    };

    return (
        <div className="mb20 ml10 clear" style={{ position: 'relative', top: '-10px' }}>
            {competency_Ids.map(c => {
                const competency = competencies.find(x => x.id === c);

                return competency ? (
                    <div className="mb5 flex flex-center" key={competency.id}>
                        <i className="fa fa-star mr5" />
                        <div className="flex-grow">{competency.name}</div>
                        <div className="text-right rating-right" style={{ minWidth: '100px' }}>
                            <Rating
                                hideLabel
                                smallStar
                                value={values[competency.id]}
                                limit={ratings}
                                onChange={x => setRating(competency.id, x)}
                            />
                        </div>
                    </div>
                ) : null;
            })}
        </div>
    );
};

export default CompetencyRatingSetter;
